import { SxProps, Theme } from '@mui/material/styles';

const PADDING_X = 2;
const DIVIDER_WIDTH = '1px';

export const modalStyles = {
	paper: (
		fullHeight: boolean,
		disableShadow: boolean,
		width?: number,
		height?: number
	): SxProps<Theme> => ({
		maxHeight: '90dvh',
		height: height ?? (fullHeight ? '90dvh' : 'unset'),
		minWidth: 0,
		overflowX: 'hidden',
		...(disableShadow && { boxShadow: 'none' }),
		...(width && { maxWidth: width })
	}),

	title: {
		px: PADDING_X,
		py: 1.5,
		color: 'text.fadedPrimary',
		fontWeight: 700,
		zIndex: 1
	},

	titleText: {
		fontWeight: 700
	},

	titleDivider:
		(scrolled: boolean): SxProps<Theme> =>
		theme => ({
			borderBottom: `${DIVIDER_WIDTH} solid var(--mui-palette-divider)`,
			boxShadow: scrolled ? theme.customShadows.scrollDown : 'none',
			transition: 'box-shadow 0.2s ease'
		}),

	titleRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 1,
		width: '100%',
		fontSize: '1.25rem'
	},

	titleSlot: {
		flex: 1,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	titleEnd: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1,
		flexShrink: 0
	},

	header:
		(scrolled: boolean, disableShadow = false): SxProps<Theme> =>
		theme => ({
			position: 'relative',
			px: PADDING_X,
			pb: 2,
			borderBottom: `${DIVIDER_WIDTH} solid var(--mui-palette-divider)`,
			boxShadow:
				scrolled && !disableShadow ? theme.customShadows.scrollDown : 'none',
			zIndex: 1,
			transition: 'box-shadow 0.2s ease'
		}),

	body: (hasFooter: boolean): SxProps<Theme> => ({
		px: PADDING_X,
		pt: 0,
		pb: hasFooter ? 0 : 2,
		overflowY: 'auto',
		minHeight: 0
	}),

	footer:
		(
			atBottom: boolean,
			footerSpacing: boolean,
			disableFooterShadow: boolean
		): SxProps<Theme> =>
		theme => ({
			px: PADDING_X,
			py: 2,
			mt: footerSpacing ? 2 : 0,
			borderTop: `${DIVIDER_WIDTH} solid var(--mui-palette-divider)`,
			boxShadow:
				disableFooterShadow || atBottom ? 'none' : theme.customShadows.scrollUp,
			zIndex: 1,
			transition: 'box-shadow 0.2s ease'
		}),

	edgeDivider: {
		alignSelf: 'stretch',
		mx: -PADDING_X,
		borderBottomWidth: DIVIDER_WIDTH
	}
};
